import React, { useState } from 'react'
import { useTranslation } from '../hooks/useTranslation'
import ContactForm from './ContactForm.jsx'

/**
 * Collapsible contact form accordion (same pattern as the home page).
 */
export default function ContactFormAccordion({
  source = 'contact_page',
  fieldIdPrefix = '',
  accordionId = 'contact-form-accordion',
  defaultOpen = false,
  className = ''
}) {
  const t = useTranslation()
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const contentId = `${accordionId}-content`

  return (
    <div className={className}>
      <div
        className={`rounded-lg border bg-white shadow-lg transition-all duration-300 hover:shadow-xl ${
          isOpen ? 'border-primary-200' : 'border-gray-200'
        }`}
        id={accordionId}
      >
        <button
          type="button"
          className="group inline-flex min-h-14 w-full touch-manipulation items-center justify-between gap-x-3 rounded-lg px-4 py-5 text-start font-semibold text-gray-800 transition hover:text-primary-darkGreen focus:outline-none focus:text-primary-darkGreen sm:px-8 sm:py-6"
          aria-expanded={isOpen}
          aria-controls={contentId}
          onClick={() => setIsOpen((open) => !open)}
        >
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-darkGreen mb-2">
              {t('contact.form.title')}
            </h2>
            <p className="text-gray-600 text-sm md:text-base">{t('contact.form.subtitle')}</p>
          </div>
          <svg
            className={`shrink-0 size-6 text-gray-600 group-hover:text-primary-darkGreen ${
              isOpen ? 'hidden' : 'block'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            aria-hidden
          >
            <path d="M8.5 0V8M8.5 16V8M8.5 8H0.5M8.5 8H16.5" stroke="currentColor" strokeWidth="2" />
          </svg>
          <svg
            className={`shrink-0 size-6 text-gray-600 group-hover:text-primary-darkGreen ${
              isOpen ? 'block' : 'hidden'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            aria-hidden
          >
            <path d="M0.5 8H16.5" stroke="currentColor" strokeWidth="2" />
          </svg>
        </button>
        <div
          id={contentId}
          className={isOpen ? 'w-full' : 'hidden w-full'}
          aria-labelledby={accordionId}
        >
          <div className="px-4 pb-8 pt-4 sm:px-8">
            <ContactForm source={source} showHeading={false} fieldIdPrefix={fieldIdPrefix} />
          </div>
        </div>
      </div>
    </div>
  )
}
